import { observer } from 'mobx-react-lite'
import React, { type FC } from 'react'
import { Dropdown } from 'shared/ui'
import { MergeField, type IMergeFieldConfig } from 'widgets/MergeField'
import styles from './styles.module.scss'

export const MergeFieldsIconAction: FC<IMergeFieldConfig> = observer((props) => {
  return (
    <Dropdown
      ariaLabel={'MergeFieldsIconAction'}
      placement={'bottom-start'}
      tooltipProps={{
        label: 'Merge fields',
        placement: 'top',
      }}
      zIndex={props.zIndex}
      sizeTriggerButton={props.sizeTriggerButton || 'medium'}
      variantTriggerButton={'icon'}
      icon={'user'}
      typeButton={'icon-button'}
      customComponent={(onCloseMenu) => (
        <div className={styles.dropdown}>
          <MergeField onCloseMenu={onCloseMenu} {...props} />
        </div>
      )}
    />
  )
})
